/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import { FontSizes, FontWeights, getTheme } from "@fluentui/react";
import React from "react";
const theme = getTheme();
export const ShowPreviewEmails = (): JSX.Element => {
    return <div style={{ fontWeight: FontWeights.regular, fontSize: FontSizes.smallPlus, color: theme.palette.neutralPrimary }}>
        <h3>Find previous emails</h3>
        <p> When you click History from the top menu ypou can see a list of mails coming from the selected sender for the period you select.</p>
        <div style={{ textAlign: 'center' }}>
            <img width='200' src={require('../../../assets/10.png')} />
        </div>
        <p>Change the time period to see previous emails from the sender of the selected email.
        </p>
        <p>For each mail appear you can preview it or you can go directly to this specific mail if you double click it.
        </p>

    </div>;
};
